import { useEffect } from 'react';

/**
 * Unsaved edits anywhere in the app, so a link can ask before throwing them
 * away. Forms report in through `useUnsaved`; links ask `confirmLeave` before
 * they go. A browser-level leave — refresh, close, typed URL — is caught by the
 * `beforeunload` prompt the hook installs while anything is dirty.
 */
let unsaved = 0;

const LEAVE_MESSAGE = 'You have unsaved changes. Leave this page and lose them?';

const onBeforeUnload = (event: BeforeUnloadEvent) => {
  event.preventDefault();
};

export function useUnsaved(dirty: boolean) {
  useEffect(() => {
    if (!dirty) return;
    unsaved += 1;
    if (unsaved === 1) window.addEventListener('beforeunload', onBeforeUnload);
    return () => {
      unsaved -= 1;
      if (unsaved === 0) window.removeEventListener('beforeunload', onBeforeUnload);
    };
  }, [dirty]);
}

/** True when it is fine to navigate: nothing is dirty, or the user agreed to drop it. */
export const confirmLeave = () => unsaved === 0 || window.confirm(LEAVE_MESSAGE);
